import * as DispatcherStream from 'dispatcher-stream'
import * as MapStream from 'pw-map-stream'
import {inspect} from 'util'

class StreamSubscriber {
  constructor({uiToWorkerDataSink, workerToUiDataStream}) {
    this.uiToWorkerDataSink = uiToWorkerDataSink
    this.workerToUiDataStream = workerToUiDataStream
    this.streams = new Map()

    this.messageDispatcher = DispatcherStream({
      dispatch: (data) => data.name,
      defaultHandler: (data) => console.error("Unknown message received" + inspect(data, {depth: null}))
    })
    this.workerToUiDataStream.pipe(this.messageDispatcher)
  }

  create(message) {
    const name = message.name
    if (this.streams.has(name)) { throw new Error("Duplicate stream name")}
    const stream = this.messageDispatcher.addOutput(name).
      pipe(MapStream((data) => {
        if (data.action === 'event') {
          stream.emit(data.eventName, data.eventData)
          return null
        } else if (data.action === 'end') {
          this.messageDispatcher.removeOutput(name) //this also ends the stream
          this.streams.delete(name)
          return null
        } else if (data.action === 'data') {
          return data.data
        }
        console.error("Unknown action received." + inspect(data, {depth: null}))
      }))

    this.streams.set(name, stream)

    stream.destroy = () => this.destroyStream(name)
    stream.update = (options) => this.updateStream(name, options)

    this.uiToWorkerDataSink.write({action: 'create', name, message})
    return stream
  }

  destroyStream(name) {
    this.uiToWorkerDataSink.write({action: 'destroy', name})
  }

  updateStream(name, options) {
    this.uiToWorkerDataSink.write({action: 'update', name, options})
  }
}

export default StreamSubscriber
